import axios, { AxiosRequestConfig } from 'axios'

import {
  IImportSrtPayload,
  IDeleteLanguagePayload,
} from './types'

const config: AxiosRequestConfig = {
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  responseType: 'json'
}

export function importSrt(payload: IImportSrtPayload) {
  const { projectVersionId, subtitleId, fileContent, enableSpeakerDiarization } = payload

  const formData = new FormData()

  formData.append('srt_content', fileContent)
  formData.append('enable_speaker_diarization', enableSpeakerDiarization.toString())

  return axios.post(`/api/v1/project_versions/${projectVersionId}/subtitles/${subtitleId}/import_srt`, formData, config)
}

export function deleteLanguage(payload: IDeleteLanguagePayload) {
  const { projectVersionId, subtitleId } = payload
  
  return axios.delete(`/api/v1/project_versions/${projectVersionId}/subtitles/${subtitleId}`, config)
}
